import {
  LayoutSettingsActionTypes,
  SET_MESSAGE_CENTER_COLLAPSED,
  SET_LAYOUT_SIDE_BAR_COLLAPSED,
} from './types';

export const setLayoutSideBarCollapsed = (
  collapsed: boolean
): LayoutSettingsActionTypes => {
  return {
    type: SET_LAYOUT_SIDE_BAR_COLLAPSED,
    collapsed,
  };
};

export const setMessageCenterCollapsed = (
  collapsed: boolean
): LayoutSettingsActionTypes => {
  return {
    type: SET_MESSAGE_CENTER_COLLAPSED,
    collapsed,
  };
};
